<template>
<nav class="fixed-top d-flex align-items-center border-bottom px-3 bg-white z-index-fixed">
    <router-link to="/" id="brand">
        <img src="/assets/img/leadgenius-dark.svg" />
    </router-link>
    <div class="right flex-box" v-click-outside="hide">
        <a v-on:click="profileClick"
            :class="{ active: isActive('profile') }" class="nav-item">
            <div class="logo-mask center-all">
                <img v-if="logoUrl" :src="logoUrl" @error="defaultImg" />
                <i v-else class="btr bt-user flush"></i>
            </div>
            <span class="space-right">{{ name }} </span>
            <i v-bind:class="{ 'fa fa-angle-down': !isProfileClicked, 'fa fa-angle-up': isProfileClicked }" aria-hidden="true"></i>
            <div v-if="isProfileClicked" id="account-dropdown">
                <ul>
                    <li>
                        <router-link to="/account/profile" style="width: 100%">
                            <i class="btr bt-user" aria-hidden="true"></i>
                            Settings
                        </router-link>
                    </li>
                    <li>
                        <a v-bind:href="logoutLink" style="width: 100%">
                            <i class="btr bt-sign-out" aria-hidden="true"></i> Sign Out
                        </a>
                    </li>
                </ul>
            </div>
        </a>
    </div>
    <div>
        <i class="fa fa-question-circle"></i>
    </div>
</nav>
</template>

<script>
import utils from '../utils/company-domain';
export default {
    name: 'Navigation',
    computed: {
        name,
        logoutLink: function() {
            return '//' + process.env.PREMIERE_URL + '/logout';
        }
    },
    methods: {
        isActive,
        profileClick,
        hide: function() {
            this.isProfileClicked = false;
        },
        show: function() {
            this.isProfileClicked = true;
        },
        defaultImg: function() {
            $(this.$el).find('.logo-mask').html('<i v-else class="btr bt-user flush"></i>');
        }
    },
    data: function() {
        const session = this.$store.state.session;
        const domain = utils.getCompanyName(session);
        const logoUrl = domain ? '//logo.clearbit.com/'+ domain +'?size=140' : null;
        return {
            isProfileClicked : false,
            iconDropdownClass: 'fa-angle-down',
            logoUrl: logoUrl
        }
    }
}

function profileClick() {
    this.isProfileClicked = !this.isProfileClicked;
}

function isActive(arr) {
    if (typeof arr === 'string') arr = [arr]
    const routes = [this.$route.name]

    let parent = this.$route.$parent;

    while (parent) {
        routes.push(parent.name)
        parent = parent.$parent
    }

    return arr.some((name) => routes.indexOf(name) !== -1)
}

function name() {
    const session = this.$store.state.session
    if (!session) return;
    return `${session.first_name} ${session.last_name}`;
}

</script>
